import { useState } from 'react';

/**
 * État ouvert/fermé d'un soufflet, mémorisé en localStorage (par clé). Permet à
 * chacun de replier un panneau et de retrouver son choix.
 */
export function usePanelOpen(key: string, dflt = true): readonly [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState<boolean>(() => {
    try {
      const v = localStorage.getItem(key);
      return v === null ? dflt : v === '1';
    } catch {
      return dflt;
    }
  });
  const set = (o: boolean): void => {
    setOpen(o);
    try {
      localStorage.setItem(key, o ? '1' : '0');
    } catch {
      /* stockage indisponible : choix gardé en mémoire de session */
    }
  };
  return [open, set] as const;
}
